module.exports = __webpack_public_path__ + "media/assets/images/brt-logo-3f798364a8ec3642e5b4feefb5c874d0.png";